import { requestUrl } from "@sm/services/backendUrl";
import { frontEndUrl } from '@sm/config';

export const crudService = {
  get,
  post,
  put,
  patch,
  remove
};

function buildUrl(endpoint, skipApi, isNotification) {
  return frontEndUrl + "/" + (isNotification ? "notifications/" : "") + (!skipApi ? requestUrl.backendUrl : "") + endpoint;
}

function getInfo(label) {
  let prop;
  try {
    const storageItem = localStorage.getItem(label);
    if (label === 'user') {
      prop = JSON.parse(storageItem);
      const loginAsUserToken = JSON.parse(localStorage.getItem('loginAsUser'));
      if (loginAsUserToken) {
        prop = loginAsUserToken;
      }
    } else {
      prop = storageItem;
    }
  } catch {
    prop = null;
  }
  return prop;
}

function get(endpoint, customHeaders, skipApiPart, isNotification) {
  const url = buildUrl(endpoint, skipApiPart, isNotification);
  const user = getInfo('user');

  const headers = Object.assign({
    'Content-Type': 'application/json'
  }, customHeaders);

  if (user) {
    headers['Authorization'] = user.tokenType + ' ' + user.accessToken;
  }

  const requestOptions = {
    method: 'GET',
    headers: headers
  };

  return fetch(url, requestOptions).then(handleResponse);
}

function post(endpoint, jsonConfig, customHeaders, isFile) {
  const url = buildUrl(endpoint);
  const user = getInfo('user');

  const headers = Object.assign({}, customHeaders);

  if (user) {
    headers['Authorization'] = user.tokenType + ' ' + user.accessToken;
  }

  const requestOptions = {
    method: "POST",
    body: jsonConfig,
    headers: headers
  };

  if (!isFile) {
    requestOptions.headers["Content-Type"] = "application/json";
    requestOptions.body = JSON.stringify(jsonConfig);
  }

  return fetch(url, requestOptions).then(handleResponse);

}

function put(endpoint, jsonConfig, customHeaders, isFile, isNotification) {
  const url = buildUrl(endpoint, false, isNotification);
  const user = getInfo('user');

  const headers = Object.assign({
    'Content-Type': 'application/json'
  }, customHeaders);

  if (user) {
    headers['Authorization'] = user.tokenType + ' ' + user.accessToken;
  }

  const requestOptions = {
    method: "PUT",
    body: jsonConfig,
    headers: headers
  };

  if (!isFile) {
    requestOptions.headers["Content-Type"] = "application/json";
    requestOptions.body = JSON.stringify(jsonConfig);
  }

  return fetch(url, requestOptions).then(handleResponse);

}

function patch(endpoint, jsonConfig, customHeaders) {
  const url = buildUrl(endpoint);
  const user = getInfo('user');

  const headers = Object.assign({
    'Content-Type': 'application/json'
  }, customHeaders);

  if (user) {
    headers['Authorization'] = user.tokenType + ' ' + user.accessToken;
  }

  const requestOptions = {
    method: "PATCH",
    body: JSON.stringify(jsonConfig),
    headers: headers
  };

  return fetch(url, requestOptions).then(handleResponse);

}

function remove(endpoint, jsonConfig, customHeaders) {
  const url = buildUrl(endpoint);
  const user = getInfo('user');

  const headers = Object.assign({
    'Content-Type': 'application/json'
  }, customHeaders);

  if (user) {
    headers['Authorization'] = user.tokenType + ' ' + user.accessToken;
  }

  const requestOptions = {
    method: "DELETE",
    body: JSON.stringify(jsonConfig),
    headers: headers
  };

  return fetch(url, requestOptions).then(handleResponse);

}

function handleResponse(response) {
  if (!response.ok) {
    if (response.status === 401) {
      localStorage.removeItem('user');
      window.location.href = "/login";
    }
    return Promise.reject(response);
  }

  const responseCloned = response.clone();
  return response.json().catch(
    () => {
      return responseCloned;
    }
  );
}
